import React, { useEffect } from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Studio from "../components/site/Studio";
import Services from "../components/site/Services";
import Testimonials from "../components/site/Testimonials";
import Location from "../components/site/Location";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

const HomePage = () => {
  useEffect(() => {
    document.title = "ONEVO · Premium Training Studio · Torino";
  }, []);
  return (
    <div className="bg-[#0a0a0a] min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Studio />
      <Services />
      <Testimonials />
      <Location />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
